/**
 *
 * @param {MainClassProps} main
 */
const processStorageTimelines = (main) => {
  const refs = /** @type {Array<TimelineMapProps>} */ (
    main.storage.get("timelines")
  );

  /** Loop trough "parent" array */
  for (const timeline of refs) {
    /** Previous delay */
    let previous = 0;
    let previousEnd = 0;

    /** Max offset values */
    const max = [0];

    /** Timeline steps */
    const steps = /** @type {Map<Number, StepProps>} */ (timeline.get("steps"));

    /** Number of steps */
    const count = steps.size;

    /** Timeline duration */
    const DURATION = /** @type {Number} */ (timeline.get("o_duration"));

    /** Timeline has defined interval offsets `1s [r(45deg)]` or not */
    const hasDefinedOffsets = timeline.get("has-defined-offsets");

    const isDefaultDuration = DURATION === -1;

    if (!DURATION) {
      continue;
    }

    for (const step of steps.values()) {
      /** Step offsets */
      const offsets = /** @type {Array<Number>} */ (step.get("offsets"));

      /** Step is percentage-based in the original */
      const isPercentage = /** @type {Boolean} */ (step.get("is-percentage"));

      /** Convert percents to time */
      if (isPercentage) {
        /** Set the default duration of 400 * count if no duration is defined */
        const duration = isDefaultDuration ? 400 * count : DURATION;

        offsets[0] = (offsets[0] / 100) * duration;
        offsets[1] = (offsets[1] / 100) * duration;

        step.set("step-duration", offsets[1] - offsets[0]);
      } else {
        let stepDuration = /** @type {Number} */ (step.get("step-duration"));
        let stepOptionDuration = /** @type {Number} */ (step.get("o_duration"));

        /** Not a default timeline duration and step duration is inherited from the timeline (has a default duration, no custom value) */
        if (DURATION !== -1 && stepOptionDuration === DURATION) {
          stepOptionDuration = stepOptionDuration / count;
        }

        if (stepOptionDuration === -1) {
          stepOptionDuration = 400;
        }

        /**
         * Not a default step duration
         * Step duration defined via options
         * @example `hover:[[tx(2rem) <1s>], [r(45deg) <4s>], [s(0.5) <8s>]]`
         */

        offsets[0] = previousEnd;
        offsets[1] = previousEnd + stepDuration;

        if (stepOptionDuration !== -1) {
          if (hasDefinedOffsets) {
            offsets[1] = stepDuration + previousEnd;
          } else {
            offsets[1] = stepOptionDuration + previousEnd;
            step.set("step-duration", stepOptionDuration);
          }
        }

        previousEnd = offsets[1];
      }

      /** Step delay */
      const delay = /** @type {Number} */ (step.get("o_delay"));

      offsets[0] = offsets[0] + delay + previous;
      offsets[1] = offsets[1] + delay + previous;

      max.push(offsets[1]);

      previous += delay;
    }

    /** Get the max offset to set a new duration */
    const newDuration = Math.max(...max);

    timeline.set("o_duration", DURATION === -1 ? newDuration : DURATION);
    timeline.set("offsets-duration", newDuration);
  }
};

export default processStorageTimelines;
